module.exports = __webpack_public_path__ + "static/fiji2-768x452-3d3004ccdb0b01f7aa4db23ae8a47332.png";